import type { CreatorStep } from '@/stores/uiStore';

/** The card only exists on the design and products steps; the pencil belongs to the products step. */
export function canEditPlacement(input: {
  isActive: boolean;
  hasDesignData: boolean;
  currentStep: CreatorStep;
}): boolean {
  return (
    input.isActive && input.hasDesignData && input.currentStep === 'products'
  );
}
